export default ".input-filter{display:flex;align-items:center;justify-content:space-between}.input-filter div:first-child{flex:1}";